module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap2"
    }
  }, [_c('i', [_vm._v("Rain Moving In")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("The blackboard is erased in the attic")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And the wind turns up the light of the stars,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Sinewy now. Someone will find out, someone will know.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And if somewhere on this great planet")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("The truth is discovered, a patch of it, dried, glazed by the sun,")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("It will just hang on, in its own infamy, humility. No one")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Will be better for it, but things can’t get any worse.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Just keep playing, mastering as you do the step")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Into disorder this one meant. Don’t you see")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("It’s all we can do? Meanwhile, great fires")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Arise, as of haystacks aflame. The dial has been set")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("And that’s ominous, but all your graciousness in living")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Conspires with it, now that this is our home:")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("A place to be from, and have people ask about.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dba58f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6chap2.vue
// module id = 75
// module chunks = 0